import { render, staticRenderFns } from "./DeleteItem.vue?vue&type=template&id=616e0f5d&scoped=true"
import script from "./DeleteItem.vue?vue&type=script&lang=ts"
export * from "./DeleteItem.vue?vue&type=script&lang=ts"
import style0 from "./DeleteItem.vue?vue&type=style&index=0&id=616e0f5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616e0f5d",
  null
  
)

export default component.exports